/**
 * Created by mateimisarca on 2019-06-07
 */

import CourseItem from './course-item';
export default CourseItem;
